import '../../CommonStyles.scss';
import './KpiCard.scss';
import { ReactNode } from 'react';
import Paper from '@trackman/web-shared-components/components/Paper/Paper';
import { DataSource } from 'types/admin/analytics';
import { KpiBase } from '../KpiBase/KpiBase';

interface KpiCardProps {
  label: string;
  sources: DataSource[];
  value: number | string;
  customClasses?: string;
  children?: ReactNode;
}

export const KpiCard = ({ label, sources, value, customClasses, children }: KpiCardProps) => (
  <Paper className={`analytics-card kpi-card ${customClasses || ''}`}>
    <KpiBase label={label} value={value.toLocaleString()} sources={sources} />
    {children && <>{children}</>}
  </Paper>
);

export default KpiCard;
